import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/**
 * Toasts of the limit form, shared by every screen that mounts it. `eventName` matches the `type` of the
 * actions dispatched by `Application/AiCostLimits/Limits/**`, `Users/**` and `Subjects/**`.
 */
const AiCostLimitFormNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="AI_COST_LIMIT_CREATED"
				title="Plafond enregistré"
				message="Le plafond a bien été enregistré."
			/>
			<SuccessNotification
				eventName="AI_COST_LIMIT_UPDATED"
				title="Plafond modifié"
				message="Le plafond a bien été modifié."
			/>
			<ErrorNotification
				eventName="AI_COST_LIMIT_CREATION_FAILED"
				title="Erreur"
				message="Le plafond n'a pas pu être enregistré."
			/>
			<ErrorNotification
				eventName="AI_COST_LIMIT_UPDATE_FAILED"
				title="Erreur"
				message="Le plafond n'a pas pu être modifié."
			/>
			<ErrorNotification
				eventName="AI_COST_LIMIT_USERS_FETCH_FAILED"
				title="Erreur"
				message="Les utilisateurs du compte n'ont pas pu être chargés."
			/>
			<ErrorNotification
				eventName="AI_COST_LIMIT_SUBJECTS_FETCH_FAILED"
				title="Erreur"
				message="Les structures et agences n'ont pas pu être chargées."
			/>
		</React.Fragment>
	);
};

export default AiCostLimitFormNotifications;
